





































































































































































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { Select } from "element-ui";

@Component({ extends: Select })
export default class extentSelect extends Vue {
  setSelected() {
    let _this: any = this;
    if (!_this.multiple) {
      let option = _this.getOption(_this.value);
      if (option.created) {
        _this.createdLabel = option.currentLabel;
        _this.createdSelected = true;
      } else {
        _this.createdSelected = false;
      }

      _this.selectedLabel = option.currentLabel;
      _this.selected = option;
      if (_this.filterable) _this.query = _this.selectedLabel;
      return;
    }
    let result = [];
    if (_this.value && _this.value.length > 0) {
      if (_this.multiple) {
        let valueItem0 = _this.value[0];
        if (
          Object.prototype.toString.call(valueItem0).toLowerCase() ===
          "[object object]"
        ) {
          result.push();
          _this.value.forEach(value => {
            result.push({ currentLabel: value.label, value: value.value });
          });
        } else {
          _this.value.forEach(value => {
            result.push(_this.getOption(value));
          });
        }
      }
    }
    _this.selected = result;
    _this.$nextTick(() => {
      _this.resetInputHeight();
    });
  }
  setSelectLabel(label) {
    let _this: any = this;
    _this.cachedOptions.push({
      value: _this.value,
      currentLabel: label
    });
    _this.setSelected();
  }
}
